import {useCallback, useEffect, useMemo, useState} from 'react';
import {useLocation} from 'react-router-dom';

import {videoTokenApi, testVideoApi} from 'api';
import {Button, KurentoRoom, KurentoVideo, Input, CopyText} from 'components';
import {WebRTCServerSource} from 'enums';
import {mediaDevicesUtils} from 'utils';

export const TestKurentoVideo: React.FC = () => {
    const [roomName, setRoomName] = useState('');
    const [started, setStarted] = useState(false);
    const {search} = useLocation();

    const getTokenFn = useCallback(
        () => videoTokenApi.getPublicInternalWebRTCToken(roomName),
        [roomName]
    );

    const mediaConstraints = useMemo(() => ({
        audioinput: mediaDevicesUtils.getMediaTrackConstraintSet(),
        videoinput: mediaDevicesUtils.getVideoTrackConstraintSet(),
    }), []);

    const stopSession = useCallback(() => {
        setStarted(false);
        testVideoApi.stopSession(WebRTCServerSource.Internal);
    }, []);

    const startSession = useCallback(() => {
        setStarted(true);
        testVideoApi.startSession(WebRTCServerSource.Internal);
    }, []);

    useEffect(() => {
        testVideoApi.openPage(WebRTCServerSource.Internal);
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(search);
        const roomNameParam = params.get('roomName');
        if (roomNameParam) {
            setRoomName(roomNameParam);
            startSession();
        }
    }, [search, startSession]);

    if (!started) {
        return (
            <div className='tw-flex tw-items-center tw-flex-col tw-p-4'>
                <div className='tw-max-w-60 tw-mb-4'>
                    <div>{'Please enter a room name:'}</div>
                    <form onSubmit={startSession}>
                        <Input value={roomName} onChange={setRoomName} />
                    </form>
                </div>
                <Button color='primary' disabled={!roomName} onClick={startSession}>
                    {'Join room'}
                </Button>
            </div>
        );
    }

    return (
        <div className='tw-h-full tw-min-w-256 tw-p-4'>
            <div className='tw-text-center'>
                <div className='tw-mb-4'>
                    <span className='tw-font-bold'>{'Room: '}</span>
                    <CopyText text={roomName} labelPlacement='left' />
                </div>
                <Button color='primary' onClick={stopSession}>
                    {'Disconnect'}
                </Button>
            </div>
            <div className='tw-flex tw-h-3/5 tw-my-4'>
                <div className='tw-flex-center tw-w-full tw-h-full tw-border tw-border-default tw-mx-4'>
                    <KurentoRoom mediaConstraints={mediaConstraints} getTokenFn={getTokenFn}>
                        {({room}) => <KurentoVideo room={room} mediaConstraints={mediaConstraints} />}
                    </KurentoRoom>
                </div>
            </div>
        </div>
    );
};
